import React, { useState, useEffect } from 'react';
import axios from 'axios';

import videoPlayIcon from '../../../assets/images/landers/trade_hub/video-play.png';
import videoInfoIcon from '../../../assets/images/landers/trade_hub/info.svg';

const VideoListItem = ({ item }) => {
  const [thumbSRC, setThumbSRC] = useState('');
  const [showInfo, setShowInfo] = useState(false);

  const { Thumbnail, Title, Link, Description } = item;

  useEffect(() => {
    if (Link !== null) {
      getThumb(Link);
    }
  }, []);

  const getThumb = (video) => {
    const videoDetails = parseURL(video);
    const videoType = videoDetails.type;
    const videoID = videoDetails.id;

    if (videoType == 'youtube') {
      setThumbSRC(
        'https://img.youtube.com/vi/' + videoID + '/maxresdefault.jpg',
      );
    } else if (videoType == 'vimeo') {
      axios
        .get(`https://vimeo.com/api/v2/video/${videoID}.json`)
        .then(({ data }) => {
          setThumbSRC(data[0].thumbnail_large);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const parseURL = (url) => {
    const newUrl = new URL(url);
    let type = '';
    let id = '';
    let path = '';
    let newId = '';

    url.match(
      /(http:|https:|)\/\/(player.|www.|m.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/,
    );

    if (RegExp.$3.indexOf('youtu') > -1) {
      type = 'youtube';
      id = RegExp.$6;
    } else if (
      RegExp.$3.indexOf('vimeo') > -1 &&
      newUrl.pathname.indexOf('channels') > -1
    ) {
      path = newUrl.pathname.split('/');
      newId = path[3];
      type = 'vimeo';
      id = newId;
    } else if (RegExp.$3.indexOf('vimeo') > -1) {
      type = 'vimeo';
      id = RegExp.$6;
    }

    return {
      type: type,
      id: id,
    };
  };

  const showVideoInfo = () => {
    setShowInfo(!showInfo);
  };

  return (
    <div>
      <div className="yt__image-wrapper">
        <a
          href={Link}
          className="yt-list__item-link"
          target="_blank"
          rel="nofollow noopener noreferrer">
          <img src={Thumbnail || thumbSRC} alt="" className="thumb" />
          <img className="yt__play-icon" src={videoPlayIcon} alt="play video" />
        </a>
        {showInfo && (
          <div className="yt__image-wrapper__info">
            <p className="yt__image-wrapper__info-text">{Description}</p>
          </div>
        )}
      </div>
      <p className="yt-list__item-title">
        <a
          href={Link}
          className="yt-list__item-link"
          target="_blank"
          rel="nofollow noopener noreferrer">
          {Title}
        </a>
        {Description && (
          <img
            src={videoInfoIcon}
            alt="information"
            onClick={() => showVideoInfo()}
          />
        )}
      </p>
    </div>
  );
};

export default VideoListItem;
